import React, { Component } from 'react'
import { observer } from 'mobx-react'

import Menu from './admin/menu'

@observer(['globals'])
export default class Admin extends Component {

  constructor(props) {
    super(props)
    this.props.globals.setCurrentPage('admin')
  }

  render() {
    return (
      <div className="main-container">
        <Menu />
        <div className="main-content">
          { React.cloneElement(this.props.children, this.props) }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin.js